import {
    ButtonSecondary,
    Dropdown,
    Heading, IconArrowLeft20, IconArrowRight20,
    ButtonPrimary,
    Input
} from "pac-ux-components";
import useAuditLog from "../../hooks/useAuditLog";
import React, {useState} from "react";
import Select from "react-select";
import {useNavigate, useLocation} from "react-router-dom";

function HistorySearch(props) {

    const navigate = useNavigate();
    const location = useLocation();
    const [userInput, setUserInput] = useState("");


    const {
        auditLogs, setAuditLogs, loading, setLoading,
        error, setError, currentPage, setCurrentPage, fetchLogPage, totalPages,
        startDate, setStartDate, endDate, setEndDate, table, setTable,
        search, setSearch
    } = useAuditLog();

    function handleClickPageLeft() {
        if (currentPage === 1 || auditLogs.length === 0) {
            return;
        }
        setCurrentPage(currentPage - 1);
    }

    function handleClickPageRight() {
        if (currentPage === totalPages || auditLogs.length === 0) {
            return;
        }
        setCurrentPage(currentPage + 1);
    }

    function handleSearch() {
        setSearch(userInput);
        setCurrentPage(0);
    }

    function handleUserInput(event) {
        setUserInput(event.target.value);
    }

    function clearSearch() {
        if (search !== '' || startDate !== '' || endDate !== '') {
            //    console.log(search);
            setSearch('');
            setStartDate('');
            setEndDate('');
            setCurrentPage(0);
        }

    }

    function compareOldAndNewData(oldData, newData) {

        if (oldData) {
            if (typeof oldData !== 'object'){
                return (
                    <li style={{color: "#008000"}}>
                        {oldData}
                    </li>);
            }
            let oldDataArray = oldData ? Object.entries(oldData) : [];
            if (newData === null) {
                return oldDataArray.map((log) => {
                    if (log[0] !== "id") {
                        return (
                            <li style={{color: "#B22222"}} key={log.id}>
                                {log[0]}: {JSON.stringify(log[1])}
                            </li>
                        );
                    }
                    return null; // Ensure to return null for cases where the condition is not met
                });
            }
        }
        if (newData) {
            if (typeof newData !== 'object'){
                return (
                    <li style={{color: "#008000"}}>
                        {newData}
                    </li>);
            }
            let newDataArray = newData ? Object.entries(newData) : [];
            if (oldData === null) {
                return newDataArray.map((log) => {
                    if (log[0] !== "id") {
                        return (
                            <li style={{color: "#008000"}} key={log.id}>
                                {log[0]}: {JSON.stringify(log[1])}
                            </li>
                        );
                    }
                    return null; // Ensure to return null for cases where the condition is not met
                });
            }
        }

        if (newData && oldData) {
            let oldDataArray = oldData ? Object.entries(oldData) : [];
            let newDataArray = newData ? Object.entries(newData) : [];
            let diff = [];
            for (let i = 0; i < newDataArray.length; i++) {
                if (JSON.stringify(oldDataArray[i][1]) !== JSON.stringify(newDataArray[i][1])) {
                    //old value in red, new value in green

                    diff.push({
                        field: oldDataArray[i][0],
                        color: "#B22222",
                        value: JSON.stringify(oldDataArray[i][1])
                    });
                    diff.push({
                        field: oldDataArray[i][0],
                        color: "#008000",
                        value: JSON.stringify(newDataArray[i][1])
                    });

                }
            }

            // Find keys in the new object not in the old object aka fields have been added to the db
            const oldDataKeys = Object.keys(oldData); // Get keys of the first object
            const newDataKeys = Object.keys(newData); // Get keys of the second object
            newDataKeys.filter((key) => !oldDataKeys.includes(key)).forEach((key) => {
                diff.push({field: key, color: "#008000", value: JSON.stringify(newData[key])});
            });

            return diff.map((log) =>
                <li key={log.id} style={{color: log.color}}>
                    {log.field}: {log.value}
                </li>
            );
        }

    }


    const handlePageChange = (newPage) => {
        setCurrentPage(Number(newPage - 1));
    };

    const options = [
        {value: "tenants", label: "Tenants"},
        {value: "stores", label: "Stores"},
        {value: "merchant_profiles", label: "Merchant Profiles"},
        {value: "payment_methods", label: "Payment Methods"},
        {value: "payment_providers", label: "Payment Providers"},
        {value: "payment_providers_payment_methods", label: "Payment Providers Payment Methods"},
        {value: "merchant_currencies", label: "Merchant Currencies"},
        {value: "merchant_profile_payment_methods", label: "Merchant Profiles Payment Methods"},
        {value: "transactions_journal", label: "Transactions Journal"},
    ];

    const handleInputChange = (option) => {
        setTable(option.value);
        // Remove query parameters from the URL
        if (option.value !== "") {
            const pathWithoutParams = location.pathname; // Current path without query params
            navigate(pathWithoutParams, {replace: true});
        }
    };


    return (<div>
            <div className="AuditLog" style={{width: 1047}}>

                <Heading color={'#10304C'} style={{paddingTop: 96, paddingBottom: 16}}

                >History Log Search</Heading>
                <div style={styles.container}>
                    <Select
                        options={options}
                        value={options.filter(function (option) {
                            return option.value === table;
                        })}
                        onChange={handleInputChange}
                        placeholder="Table Name"
                        styles={customSelectStyles}
                    />

                    <Input
                        style={styles.input}
                        value={userInput}
                        onChange={handleUserInput}
                        placeholder="User"
                    />

                    <Input
                        type="date"
                        value={startDate}
                        placeholder={"Start Date"}
                        onChange={(e) => setStartDate(e.target.value)}
                        style={styles.input}
                    />
                    <Input
                        type="date"
                        value={endDate}
                        placeholder={"End Date"}
                        onChange={(e) => setEndDate(e.target.value)}
                        style={styles.input}
                    />

                </div>

                <div style={styles.container}>
                    <ButtonSecondary
                        onClick={clearSearch}
                    >
                        Clear
                    </ButtonSecondary>
                    <ButtonPrimary
                        onClick={handleSearch}
                    >
                        Search
                    </ButtonPrimary>
                </div>

                <table width="1047px" className="Table" style={{}}>
                    <thead>
                    <tr style={{
                        fontWeight: 600,
                        height: 48,
                        fontSize: 16,
                        fontFamily: 'Inter',
                        border: "thin solid #E0E0E0"
                    }}>
                        <td width="100">Operation</td>
                        <td width="100">Id</td>
                        <td width="50%">Data Changed</td>
                        <td width={120}>Changed By</td>
                        <td width={120}>Changed On</td>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? <tr>
                        <td colSpan={5} style={{textAlign: 'center', padding: 16}}>Loading...</td>
                    </tr> : null}

                    {auditLogs.map((log, index) => (<tr key={log.id} style={{
                        height: 48,
                        fontSize: 16,
                        fontWeight: 400,
                        backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                        border: "thin solid #E0E0E0"
                    }}>
                        <td>
                            {log.operationType}
                        </td>
                        <td>
                            {log.tableRowId}
                        </td>
                        <td> {compareOldAndNewData(log.oldData, log.newData)}</td>
                        <td>
                            {log.changedBy}
                        </td>
                        <td>
                            {log.changedAt}
                        </td>
                    </tr>))}
                    </tbody>
                </table>
                <div style={{marginTop: 10, width: 1047}}>
        <span>
          {auditLogs.length > 0 ? `${(currentPage) * 20 + 1} - ${Math.min((currentPage + 1) * 20, auditLogs.length)} of ${auditLogs.length}` : '0 results'}
        </span>
                    <span style={{float: 'right'}}>
          Page{' '}

                        <Dropdown
                            options={Array.from({length: totalPages}).map((_, index) => ({
                                    value: index + 1, disabled: false, label: index + 1
                                })
                            )}
                            disabled={auditLogs.length === 0}
                            selected={currentPage + 1}
                            style={{width: 62, marginRight: 4}}
                            onChange={handlePageChange}
                        />
                of {totalPages}

                        <span style={{marginLeft: 32}}>
                    <IconArrowLeft20
                        style={{
                            margin: 8,
                            cursor: (currentPage === 1) ? 'auto' : 'pointer',
                        }}
                        color={currentPage === 1 ? '#ADADAD' : '#000000'}
                        onClick={handleClickPageLeft}
                    />
                    <IconArrowRight20
                        style={{
                            margin: 8,
                            cursor: (currentPage === totalPages || auditLogs.length === 0) ? 'auto' : 'pointer',
                        }}
                        color={(currentPage === totalPages || auditLogs.length === 0) ? '#ADADAD' : '#000000'}
                        onClick={handleClickPageRight}
                    />
                </span>
        </span>

                </div>

            </div>
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        gap: "15px", // Space between inputs
        justifyContent: "space-between",
        alignItems: "center",
        margin: "20px 0",
    },
    input: {
        flex: 1,
        padding: "10px",
        fontSize: "16px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
    },
};

const customSelectStyles = {
    container: (provided) => ({
        ...provided,
        flex: 1,
    }),
};

export default HistorySearch;